import React from 'react';
import Select from 'react-select';
import classnames from 'classnames';
import './styles/SelectField.css';

const TextField = ({
    options,
    name,
    placeholder,
    value,
    error,
    info,
    type,
    onChange,
    onBlur,
    disabled,
    label,
    required = null
}) => {
    return (
        <div className={`form-group ${required === null ? "" : "required"}`}>
            <label htmlFor={name} className="labelStyles">
                {label}
                </label>
            <Select
                options={options}
                classNamePrefix="react-select"
                className={
                    classnames('react-select-container',
                        {
                            'is-invalid': error
                        }
                    )}                
                name={name}                
                onChange={onChange}
                onBlur={onBlur}
                disabled={disabled}
            />
            {info && <small className="form-text text-muted">{info}</small>}
            {error && <div className="invalid-feedback">{error}</div>}
        </div>
    );
};

export default TextField;



// WEBPACK FOOTER //
// ./src/components/common/SelectField.js